import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { authAxios as axios } from "shared-auth";
import { useErrorBoundary } from "component-library";
import { HALManager, UserManager } from "core";
import Training from "models/Training";
import { getApiUrl } from "services/UrlBuilder";
import { usePublicView } from "pages/Profile/hooks/usePublicView";
import { useGetPublicProfile } from "pages/Profile/hooks/useGetPublicProfile";

export const GET_TRAINING_QUERY_KEY = "GET_TRAINING_QUERY_KEY";

export function useGetTraining() {
  const captureError = useErrorBoundary();
  const { isPublicView } = usePublicView();
  const { data: publicProfileData, isLoading: isPublicProfileLoading } =
    useGetPublicProfile();

  const { data: trainingData, isLoading: isTrainingLoading } = useQuery<
    Training,
    AxiosError
  >(
    GET_TRAINING_QUERY_KEY,
    async () => {
      const { data } = await axios.get(
        getApiUrl(HALManager.getTrainingUrl(UserManager.userId))
      );

      return data;
    },
    {
      enabled: !isPublicView,
      cacheTime: 0,
      onError: captureError,
    }
  );

  const isLoading = isPublicProfileLoading || isTrainingLoading;

  const notes = isPublicView
    ? publicProfileData?.training?.notes
    : trainingData?.notes;

  return {
    notes,
    isLoading,
  };
}
